<template>
    <v-container id="telsasoft-geomap" class="fill-height" style="display: block;" fluid :class="{'widget-mode': $props.widgetMode}">


    <template v-if="$store.state.batchConfig.webapp_geomap">
        <div id="js-geomap" style="height: 100%; width: 100%;"></div>
        <map-item-info-window ref="mapItemInfoWindow" id="map-item-info-window" :infoWindowElementCtr="infoWindowElementCtr" @close="infoWindowOpen = false; selectedMapItem = null;" :map="googleMapsObj" :mapItem="selectedMapItem" :alarmGridResources="alarmGridResources" :activeCoverageSectIds="activeCoverageSectIds" @navigate="navigateToMarker" @showCoverage="showCoverageData" @hideCoverage="hideCoverageData" v-if="infoWindowOpen" />
        <map-item-context-window :infoWindowElementCtr="infoWindowElementCtr" :map="googleMapsObj" :mapItem="rightClickedMapItem" :sites="contextWindowItems" @close="contextWindowOpen = false; rightClickedMapItem = null;" @site-click="(site) => mapItemClicked(null, site)" @redrawPolygons="applySectorFiltersToDrawPolygons" v-if="contextWindowOpen" />
        <usage-density-polygon-info-window ref="usageDensityPolygonInfoWindow" :infoWindowElementCtr="infoWindowElementCtr" :map="googleMapsObj" :selectedUsageDensityPolygon="selectedUsageDensityPolygon" @close="selectedUsageDensityPolygon = null" v-if="selectedUsageDensityPolygon" />
        
        <v-select light class="geomap-view-select" solo label="Geo Map View" color="#c42111" :items="geoMapViewsFavs" v-model="selectedGeoMapView" return-object item-text="view_name" @change="applyGeoMapView" height="40" v-if="allResourcesFetched">
            <template v-slot:item="{item}">
                <span v-text="item.view_name" />
                <span class="geomap-view-select-default-text" v-text="'DEFAULT'" v-if="item.default" />
            </template>
        </v-select>

        <v-autocomplete attach="#search-control-toggle" autofocus class="search-bar" :placeholder="sitesSearchProperty == 'name' ? 'Search Site Name' : 'Search Site Location'" @change="panToMarker" return-object height="40" light solo :items="Object.values(this.markersDict)" :item-text="sitesSearchProperty" v-if="showSearch">
            <template v-slot:prepend-inner>
                <v-menu light right nudge-bottom="25" nudge-left="10">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon style="margin-top: -6px;" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                    </template>
                    <v-list>
                        <v-list-item :style="{backgroundColor: sitesSearchProperty == 'name' ? 'rgba(196, 33, 17, 0.6)' : '#fff'}" @click="sitesSearchProperty = 'name'"><v-list-item-title>Site Name</v-list-item-title></v-list-item>
                        <v-list-item :style="{backgroundColor: sitesSearchProperty == 'location' ? 'rgba(196, 33, 17, 0.6)' : '#fff'}" @click="sitesSearchProperty = 'location'"><v-list-item-title>Site Location</v-list-item-title></v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-autocomplete>

        <v-combobox attach="#marker-control-toggle" class="places-search-bar"  v-model="placesSearchSelection" @change="setPlacesSearchMarker" :items="placesSearchResults" :search-input.sync="placesSearchValue" :placeholder="placesSearchTypeText" return-object height="40" light solo v-if="placesSearchShow">
            <template v-slot:prepend-inner>
                <v-menu light right nudge-bottom="25" nudge-left="10">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon style="margin-top: -6px;" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                    </template>
                    <v-list>
                        <v-list-item :style="{backgroundColor: placesSearchType == 'latlng' ? 'rgba(196, 33, 17, 0.6)' : '#fff'}" @click="changePlacesSearchType('latlng')"><v-list-item-title>Lat,Lng</v-list-item-title></v-list-item>
                        <v-list-item :style="{backgroundColor: placesSearchType == 'places' ? 'rgba(196, 33, 17, 0.6)' : '#fff'}" @click="changePlacesSearchType('places')"><v-list-item-title>Places</v-list-item-title></v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:item="data">
                <v-list-item-content>
                    <v-list-item-title v-html="data.item.title"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.subtitle"></v-list-item-subtitle>
                </v-list-item-content>
            </template>
        </v-combobox>
    </template>

    <template v-if="!$store.state.batchConfig.webapp_geomap">
        <div class="no-license-text">
            <p>
                You do not have a license for Telsasoft Geomap. </br>
                Please visit <a style="color:#c42111;" href="https://telsasoft.com/tecalert/" target="_blank">here</a> for more information.
            </p>
        </div>
    </template>

    <v-dialog v-model="showGeoMapSettings" max-width="80%" width="1600px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showGeoMapSettings = false : null}" v-if="showGeoMapSettings">
        <geo-map-settings v-if="showGeoMapSettings" :generalSettings="generalSettings"
            :geoSiteList="geoSiteList"
            :siteSeverityFilters="siteAlarmFilters" :linkSeverityFilters="linkAlarmFilters" 
            :siteTags="siteTags" :siteTagFilters="siteTagFilters" 
            :siteTechnicians="siteTechnicians" :siteTechnicianFilters="siteTechnicianFilters" 
            :networkCategories="networkCategories" :siteNetworkCategoryFilters="siteNetworkCategoryFilters"
            :advancedFilters="advancedFilters" :advancedFiltersValueLists="advancedFiltersValueLists" :alarmGridResources="alarmGridResources" :alarmViews="alarmViews"
            @close="showGeoMapSettings = false" 
        />
    </v-dialog>

    <v-dialog v-model="showGeoMapViewManagement" max-width="80%" width="1600px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showGeoMapViewManagement = false : null}">
        <geo-map-view-management v-if="showGeoMapViewManagement" :mapViews="geoMapViews" @open="(view) => {this.selectedGeoMapView = view; this.applyGeoMapView()}" @delete="() => {this.buildMapViewsList();}" @close="showGeoMapViewManagement = false" />
    </v-dialog>

    <v-dialog v-model="showViewsFavsDetails" max-width="80%" width="550px" persistent v-if="showViewsFavsDetails" @keydown="(k) => {k.key == 'Escape' ? showViewsFavsDetails = false : null}">
        <views-favs-details :viewType="'geomap'" :selectedView="selectedGeoMapView" :views="geoMapViews" @cancel="showViewsFavsDetails = false" @new="saveNewView" @overwrite="overwriteView"></views-favs-details>
    </v-dialog>

    </v-container>
</template>

<script>
import { GoogleMapStyles, GoogleMapStyleFeatureDensityModifiers } from "@/components/GeoMap/GoogleMapStyles";
import { fetchGeoMapResources, getMarkerIcon, getPolylineOptions, animatePolylineSymbols, mapItemVisible, mapItemZIndex, createAdvancedMarkerElement, createPolylineElement, removeListeners } from "@/components/GeoMap/GeoMapAPI";
import { buildCustomMapControls, hideActiveMapViewNameText, buildMapViewsList, buildUnMatchedAlarmsListControl, saveNewView, overwriteView } from "@/components/GeoMap/GeoMapControlsAPI";
import { setPlacesSearchMarker, changePlacesSearchType, handlePlacesSearchValue } from "@/components/GeoMap/GeoMapPlacesAPI";
import { getUsageDensityPolygonData, buildUsageDensityPolygons } from "@/components/GeoMap/GeoMapUsageDensityAPI";
import { fetchCoverageData, showCoverageData, hideCoverageData, buildCoveragePolygons } from "@/components/GeoMap/GeoMapCoverageAPI";

import GeoMapSettings from "@/components/GeoMap/GeoMapSettings";
import GeoMapViewManagement from "@/components/GeoMap/GeoMapViewManagement";
import ViewsFavsDetails from "@/components/ViewsFavsDetails";

import MapItemInfoWindow from "@/components/GeoMap/MapItemInfoWindowNew";
import MapItemContextWindow from "@/components/GeoMap/MapItemContextWindowNew";
import UsageDensityPolygonInfoWindow from "@/components/GeoMap/UsageDensityPolygonInfoWindow";

import { MarkerClusterer } from "@googlemaps/markerclusterer";

export default {
    name: 'GeoMap',
    props: ['widgetMode'],
    components: {
        GeoMapSettings,
        GeoMapViewManagement,
        ViewsFavsDetails,
        MapItemInfoWindow,
        MapItemContextWindow,
        UsageDensityPolygonInfoWindow
    },
    data: () => ({
        // Map obj stuff
        API_KEY: 'AIzaSyCT5eLcVMKyPSicy_5iEn8onYno7aHnAgQ',
        googleMapsObj: null,
        AdvancedMarkerElement: null,    // This is Google's AdvancedMarkerElement Constructor 
        infoWindowElementCtr: null,     // This is Google's InfoWindow Constructor
        shiftKeyPressed: false,
        dragStartListener: null,


        // Resources
        allResourcesFetched: false,
        geoSiteList: [],
        remoteSectorsLinkLines: [],
        siteTags: [],
        siteTechnicians: [],
        networkCategories: [],
        alarmGridResources: null,
        alarmViews: [],
        advancedFiltersValueLists: {},
        geoMapViews: [],


        // Heatmap stuff
        heatmapPolygonData: [],
        heatmapPolygonResultKey: 0,
        usageDensityPolygons: [],
        usageDensityPolygonElements: [],
        selectedUsageDensityPolygon: null,
        usageDensityPolygonFetchInterval: 60000,
        usageDensityPolygonFetchTimeout: null,


        // Navigation Stuff
        directionsService: null,
        directionsRenderer: null,


        // Alarm stuff
        alarmsList: [],
        unMatchedAlarms: {
            list: [],
            criticalCount: 0,
            majorCount: 0,
            minorCount: 0,
            observationalCount: 0,
            defaultCount: 0,
        },


        // Places stuff
        placesSearchShow: false,
        placesService: null,
        placesAutoCompleteService: null,
        placesSearchType: "latlng",
        placesSearchValue: "",
        placesSearchSelection: null,
        placesSearchLoading: false,
        placesSearchResults: [],
        placesMarkers: [],


        // Controls, Filters, and Settings
        showViewControls: false,
        showGeoMapSettings: false,
        showGeoMapViewManagement: false,
        showViewsFavsDetails: false,
        showSearch: false,
        selectedGeoMapView: null,
        autoCycleFunc: null,
        currentCycleMapViewIndex: 0,
        autoCycleSettings: {
            mapViews: [],
            autoCycleEnabled: false,
            autoCycleTime: 5
        },
        sitesSearchProperty: 'name',
        siteAlarmFilters: {
            critical: true,
            major: true,
            minor: true,
            observational: true,
            normal: true,
            default: true,
            serviceAffecting: false
        },
        siteAlarmFiltersClone: null,
        linkAlarmFilters: {
            critical: true,
            major: true,
            minor: true,
            observational: true,
            normal: true,
            default: true,
            serviceAffecting: false
        },
        linkAlarmFiltersClone: null,
        siteTagFilters: [],
        siteTechnicianFilters: [],
        siteNetworkCategoryFilters: [],
        advancedFilters: [],
        generalSettings: {
            mapType: 'roadmap',
            mapTheme: 'standard',
            featureDensityRoads: 3,
            featureDensityLandmarks: 3,
            featureDensityLabels: 3,
            networkCategoryIcons: true,
            showLinkDirectionality: true,
            clusterSites: false
        },


        //Map Items
        processAlarmsWorker: null,
        processAlarmsIntervalFunc: null,
        listenersDict: [],
        markersDict: {},
        remoteSectorsMarkersDict: {},
        polylinesDict: {},
        remoteSectorsLinkLinesDict: {},
        mapElementsDict: {},
        shiftClickedMarkers: [],
        mousedOverMarker: null,
        polylineSymbolPositions: {
            one: 25,
            two: 50,
            three: 75,
            four: 100
        },
        animationFrameId: null,
        animationLastTimestamp: 0,
        markerClusterer: null,


        // Info/Context Window Stuff
        selectedMapItem: null,
        infoWindowOpen: false,
        contextWindowItems: [],
        rightClickedMapItem: null,
        contextWindowOpen: false,



        coveragePolygons: [],
        activeCoverageSectIds: []
    }),

    computed: {
        geoMapViewsFavs() {
            return this.geoMapViews.length ? this.geoMapViews.filter(v => {return v.fav}) : [];
        },

        placesSearchTypeText() {
            if(this.placesSearchType == 'latlng') {
                return 'Enter Lat,Lng';
            }
            else if(this.placesSearchType == 'places') {
                return 'Search Places';
            }
        },

        usageDensityMarkers() {
            let rightClickedMarker = this.rightClickedMapItem ? (!this.rightClickedMapItem.isLink ? [this.rightClickedMapItem] : []) : [];
            let mousedOverMarker = this.mousedOverMarker ? [this.mousedOverMarker] : [];
            let startMarkers = mousedOverMarker.concat(this.shiftClickedMarkers).concat(rightClickedMarker);
            let positionMarkers = [];
            let allMarkers = Object.values(this.markersDict).concat(Object.values(this.remoteSectorsMarkersDict));
            // Ok we have a good start of all the markers, but we need to account for the markers that are "underneath" ones we already have. I.E. markers with the same position.
            for(let startMarker of startMarkers) {
                positionMarkers = positionMarkers.concat(allMarkers.filter(m => m.sectors && m.sectors.length && (TELSA.hash(m.position) == TELSA.hash(startMarker.position))));
            }
            return positionMarkers;
        }
    },

    methods: {
        createCycleMapViewsControl(controlDiv, self) { return createCycleMapViewsControl(controlDiv, self); },
        buildMapViewsList() { return buildMapViewsList(this) },
        hideActiveMapViewNameText() { return hideActiveMapViewNameText() },
        saveNewView(newView) { return saveNewView(this, newView) },
        overwriteView() { return overwriteView(this) },
        setPlacesSearchMarker(val) { return setPlacesSearchMarker(this, val) },
        changePlacesSearchType(type) { return changePlacesSearchType(this, type) },
        animatePolylineSymbols(timestamp) { return animatePolylineSymbols(this, timestamp) },
        getUsageDensityPolygonData(interval) { return getUsageDensityPolygonData(this, interval) },
        buildUsageDensityPolygons() { return buildUsageDensityPolygons(this) },
        buildCoveragePolygons(geoJson) { return buildCoveragePolygons(this, geoJson) },
        showCoverageData(sectorIds) { return showCoverageData(this, sectorIds) },
        hideCoverageData(sectorIds) { return hideCoverageData(this, sectorIds) },
        

        async setup() {
            await this.loadGoogleMapsScript();
            await this.initMap();
            await this.fetchResources();
            this.allResourcesFetched = true;
            
            // Setup Web Worker
            this.alarmsList = this.$store.state.alarmsList;
            this.processAlarmsWorker = new Worker("@/components/GeoMap/AdvProcessGeoMapAlarmsWorker", { type: 'module' });
            await this.createMapItems();

            // Apply default view. This needs to be after the createMapItems because otherwise there wouldn't be any mapItems to apply filters to!
            if(this.selectedGeoMapView) {
                this.applyGeoMapView();
            }

            // set up process alarms interval function
            let processAlarmsInterval = 5000;
            // if(this.$store.state.batchConfig.geomap_process_interval_ms && Number.isInteger(this.$store.state.batchConfig.geomap_process_interval_ms) && this.$store.state.batchConfig.geomap_process_interval_ms > 5000) {
            //     console.log('USING CUSTOM PROCESS ALARMS INTERVAL');
            //     processAlarmsInterval = self.$store.state.batchConfig.geomap_process_interval_ms;
            // }
            console.log('PROCESS ALARMS INTERVAL: ', + processAlarmsInterval);
            this.processAlarmsIntervalFunc = setInterval(() => {
                this.processAlarms(false).then(updates => {
                    this.applyAlarmUpdates(updates);
                });
            }, processAlarmsInterval);
        },

        // Load the Google Maps API script dynamically
        async loadGoogleMapsScript() {
            return new Promise((resolve, reject) => {
                if (window.google && window.google.maps) {
                    console.log('google maps already exists');
                    return resolve(); // google maps already exists
                }
                const script = document.createElement("script");
                script.src = `https://maps.googleapis.com/maps/api/js?key=${this.API_KEY}&callback=initMap&loading=async&libraries=places,geometry&v=beta`;  // Beta is used for the click event handlers on adv markers

                // This url is for legacy back when we needed to specify the libraries we wanted in the URL.
                //script.src = `https://maps.googleapis.com/maps/api/js?key=${this.API_KEY}&libraries=places,visualization,geometry&callback=initMap&loading=async`;
                script.async = true;
                script.defer = true;
                // Add the script to the document
                document.head.appendChild(script);
                // Set the callback function for when the script is loaded
                window.initMap = () => {
                    resolve();
                };
                // Handle script loading failure
                script.onerror = () => reject("Google Maps API script failed to load.");
            });
        },

        // Initialize the map
        async initMap() {
            // Get the needed stuff we need
            const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");
            const { InfoWindow } = await google.maps.importLibrary("maps");
            this.AdvancedMarkerElement = AdvancedMarkerElement;
            this.infoWindowElementCtr = InfoWindow;

            const googleMapsOptions = {
                // center: { lat: 36.0822, lng: -80.8000 }, // TODO change this to something generic
                // zoom: 12,
                center: { lat: 40, lng: -100 }, // USA
                zoom: 6,
                mapId: '1eb73715207bcf22',
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: true,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
                scrollwheel: true,
            }
            this.googleMapsObj = new google.maps.Map(document.getElementById("js-geomap"), googleMapsOptions);
            this.dragStartListener = this.googleMapsObj.addListener('dragstart', hideActiveMapViewNameText);
        },

        async fetchResources() {
            TELSA.loading(true);
            this.getUsageDensityPolygonData(this.usageDensityPolygonFetchInterval);
            await fetchGeoMapResources(this); // go get all the needed resources
            await this.getGeoMapViews();
            await this.getAutoCycleSettings();
            TELSA.loading(false);
        },


        getGeoMapViews() {
            let route = `${TELSA.apiHost}views/list/geomap`;
            return this.$http.get(route).then(response => {
                let results = response.body;
                this.geoMapViews = results;
                // We need to "sanitize" the view data and remove any site tag, site tech, network category, etc... filters that no longer exist
                let siteTagIds = this.siteTags.map(x => x.site_group_id);
                let siteTechnicianIds = this.siteTechnicians.map(x => x.user_id);
                let networkCategoryIds = this.networkCategories.map(x => x.network_category_id);
                for(let geoMapView of this.geoMapViews) {
                    geoMapView.view_grid_config.generalSettings.featureDensityRoads = geoMapView.view_grid_config.generalSettings.featureDensityRoads == null ? 3 : geoMapView.view_grid_config.generalSettings.featureDensityRoads;
                    geoMapView.view_grid_config.generalSettings.featureDensityLandmarks = geoMapView.view_grid_config.generalSettings.featureDensityLandmarks == null ? 3 : geoMapView.view_grid_config.generalSettings.featureDensityLandmarks;
                    geoMapView.view_grid_config.generalSettings.featureDensityLabels = geoMapView.view_grid_config.generalSettings.featureDensityLabels == null ? 3 : geoMapView.view_grid_config.generalSettings.featureDensityLabels;
                    geoMapView.view_grid_config.siteTagFilters = geoMapView.view_grid_config.siteTagFilters.filter(x => siteTagIds.includes(x));
                    geoMapView.view_grid_config.siteTechnicianFilters = geoMapView.view_grid_config.siteTechnicianFilters.filter(x => siteTechnicianIds.includes(x));
                    geoMapView.view_grid_config.siteNetworkCategoryFilters = geoMapView.view_grid_config.siteNetworkCategoryFilters.filter(x => networkCategoryIds.includes(x));
                }
                this.selectedGeoMapView = this.selectedGeoMapView || this.geoMapViewsFavs.find(v => {return v.default}) || (this.geoMapViewsFavs.length ? this.geoMapViewsFavs[0] : null);
            });
        },
        
        async getAutoCycleSettings() {
            let route = (TELSA.apiHost + "geomap/autocyclesettings");
            let result = (await this.$http.get(route)).body;
            if(result) {
                // Verify that the geoMapViews in the autoCycleSettings still exist
                let sanitizedAutoCycleMapViews = [];
                if(result.mapViews && result.mapViews.length) {
                    for(let autoCycleMapView of result.mapViews) {
                        if(this.geoMapViews.find(gmv => gmv.user_id == autoCycleMapView.user_id && gmv.view_name == autoCycleMapView.view_name)) {
                            sanitizedAutoCycleMapViews.push(autoCycleMapView);
                        }
                    }
                }
                result.mapViews = sanitizedAutoCycleMapViews;
                this.autoCycleSettings = result;
            }

            await buildCustomMapControls(this);
            buildUnMatchedAlarmsListControl(this);
            this.placesAutoCompleteService = new google.maps.places.AutocompleteService();
            this.placesService = new google.maps.places.PlacesService(this.googleMapsObj);
            if(this.autoCycleSettings.autoCycleEnabled) {
                this.setupAutoCycleFunc();
            }
        },

        applyGeoMapView() {
            let view = JSON.parse(JSON.stringify(this.selectedGeoMapView.view_grid_config));
            this.generalSettings = view.generalSettings;
            this.siteAlarmFilters = view.siteAlarmFilters;
            this.linkAlarmFilters = view.linkAlarmFilters;
            this.siteTagFilters = view.siteTagFilters;
            this.siteTechnicianFilters = view.siteTechnicianFilters;
            this.siteNetworkCategoryFilters = view.siteNetworkCategoryFilters;
            this.advancedFilters = view.advancedFilters;
            this.panToMapView(this.selectedGeoMapView);
        },

        panToMapView(mapView) {
            this.googleMapsObj.setZoom(mapView.view_grid_config.map_zoom);
            this.googleMapsObj.panTo(mapView.view_grid_config.map_coordinates);
            document.getElementById('active-view-name-text-container').style.display = "block";
            document.getElementById('active-view-name-text-container').innerHTML = `
                <span>${mapView.view_name}</span>
            `;
            let width = document.getElementById('active-view-name-text-container').offsetWidth;
            document.getElementById('active-view-name-text-container').style.marginLeft = `-${width / 2}px`;
        },

        panToMarker: function(marker) {
            if(marker) {
                this.googleMapsObj.setZoom(14);
                this.googleMapsObj.panTo(marker.position);
            }
        },

        navigateToMarker() {
            let self = this;
            let navigate = function(currentPosition) {
                self.directionsService = new google.maps.DirectionsService();
                self.directionsRenderer = new google.maps.DirectionsRenderer();
                self.directionsRenderer.setMap(self.googleMapObj);
                self.directionsRenderer.setPanel(document.getElementById('google-maps-directions-container'));
                document.getElementById('google-maps-directions-container').style.display = 'block';
                let request = {
                    origin: { lat: currentPosition.coords.latitude, lng: currentPosition.coords.longitude },
                    destination: self.selectedMapItem.position,
                    travelMode: 'DRIVING'
                };
                self.directionsService.route(request, function(result, status) {
                    if (status == 'OK') {
                        self.directionsRenderer.setDirections(result);
                    }
                });
            }

            let device = self.$store.state.user.client_device;
            // If they're using a android, iOS, or iPadOS then open the directions in the google maps app
            if(device.os_name.toLowerCase() == 'ios' || device.os_name.toLowerCase() == 'android' || device.os_name.toLowerCase() == 'ipados') {
                window.name = 'telsawebapp';
                window.open(`https://www.google.com/maps/dir/?api=1&map_action=map&destination=${self.selectedMapItem.position.lat},${self.selectedMapItem.position.lng}&travelmode=driving`, 'telsawebapp');
            }
            else {
                navigator.geolocation.getCurrentPosition(navigate);
            }
        },


        mapItemClicked(e, mapItem) {
            if(mapItem.remoteSectorId) {
                mapItem = this.markersDict[mapItem.siteId];
            }
            if(this.shiftKeyPressed && !mapItem.isLink) {
                this.markerShiftClick(mapItem);
                return;
            }
            if(mapItem.isLink) {
                if(e) {
                    mapItem.position = {lat: e.latLng.lat(), lng: e.latLng.lng()};
                }
                else {
                    // This means that they selected the polyline from the context menu instead of clicking on it directly from the map.
                    mapItem.position = this.rightClickedMapItem.position;
                }
            }
            this.contextWindowOpen = false; // this is the right click menu window
            this.contextWindowItems = [];
            this.rightClickedMapItem = null;
            this.selectedMapItem = mapItem;
            this.infoWindowOpen = true;
        },

        markerShiftClick: function(marker) {
            let idx = this.shiftClickedMarkers.findIndex(m => m.siteId == marker.siteId);
            if(idx > -1) { // deselct
                this.shiftClickedMarkers.splice(idx, 1);
            }
            else {
                this.shiftClickedMarkers.push(marker);
            }
        },

        mapItemMouseOver(e, mapItem) {
            if(mapItem.remoteSectorId) {
                this.mapElementsDict[`rsm_link_${mapItem.remoteSectorId}`].setVisible(true);
            }
            if(!mapItem.isLink) {
                this.mousedOverMarker = mapItem;
            }
        },

        mapItemMouseOut(e, mapItem) {
            if(mapItem.remoteSectorId) {
                this.mapElementsDict[`rsm_link_${mapItem.remoteSectorId}`].setVisible(false);
            }
            if(!mapItem.isLink) {
                this.mousedOverMarker = null;
            }
        },

        mapItemRightClick(e, mapItem) {
            if(mapItem.remoteSectorId) {
                mapItem = this.markersDict[mapItem.siteId];
            }
            let matches = [];
            if(mapItem.isLink) {
                matches = Object.values(this.polylinesDict).filter(p => {
                    return (TELSA.hash(p.path.sort((a, b) => a.lat - b.lat)) == TELSA.hash(mapItem.path.sort((a, b) => a.lat - b.lat)));
                });
                mapItem.position = {lat: e.latLng.lat(), lng: e.latLng.lng()}; // set the postiton to where they clicked.
            }
            else {
                matches = Object.entries(this.markersDict).filter(([key, value]) => TELSA.hash(value.position) === TELSA.hash(mapItem.position)).map(([key, value]) => value);
            }
            matches.sort((a, b) => mapItemZIndex(this, b) - mapItemZIndex(this, a));
            this.contextWindowItems = matches;
            this.rightClickedMapItem = mapItem;
            this.contextWindowOpen = true;
        },



        async createMapItems() {
            let mapItems = await this.processAlarms(true); // this calls the webworker and tells it we're building the initial elements.

            for(let [idx, marker] of mapItems.markers.entries()) {
                this.markersDict[marker.siteId] = marker;
                this.mapElementsDict[marker.siteId] = createAdvancedMarkerElement(this, marker, marker.siteId);
            }
            for(let [idx, polyline] of mapItems.polylines.entries()) {
                this.polylinesDict[polyline.siteId] = polyline;
                this.mapElementsDict[polyline.siteId] = createPolylineElement(this, polyline);
            }
            // These are never updated. They're just created once and done.
            for(let [idx, polyline] of this.remoteSectorsLinkLines.entries()) {
                polyline.options.map = this.googleMapsObj;
                polyline.options.path = polyline.path;
                this.mapElementsDict[polyline.ref] = new google.maps.Polyline(polyline.options);
                this.remoteSectorsLinkLinesDict[polyline.ref] = polyline;
            }
            for(let [idx, marker] of mapItems.remoteSectorsMarkers.entries()) {
                this.remoteSectorsMarkersDict[marker.remoteSectorId] = marker;
                this.mapElementsDict[marker.remoteSectorId] = createAdvancedMarkerElement(this, marker, marker.remoteSectorId);
            }
            this.unMatchedAlarms.list = mapItems.unMatchedAlarmsList;
            buildUnMatchedAlarmsListControl(this);
            if(this.generalSettings.clusterSites) {
                this.buildMarkerClustering();
            }

            // console.log('this.markersDict: ', this.markersDict);
            // console.log('this.polylinesDict: ', this.polylinesDict);
            // console.log('this.remoteSectorsMarkersDict: ', this.remoteSectorsMarkersDict);
            // console.log('this.remoteSectorsLinkLinesDict: ', this.remoteSectorsLinkLinesDict);
            // console.log('this.unMatchedAlarmsList: ', this.unMatchedAlarmsList);
        },

        rebuildMapElement(mapElementId, mapItem) {
            if(mapItem.isLink) {
                this.mapElementsDict[mapItem.siteId].setOptions(getPolylineOptions(this, mapItem)); // we dont need to remove/re-add polylines becaise they support updates
                this.mapElementsDict[mapItem.siteId].setVisible(mapItemVisible(this, mapItem));
            }
            else {
                //this.mapElementsDict[mapElementId].remove();
                this.mapElementsDict[mapElementId].map = null;
                delete this.mapElementsDict[mapElementId];
                this.mapElementsDict[mapElementId] = createAdvancedMarkerElement(this, mapItem, mapElementId);
                this.mapElementsDict[mapElementId].style.display = mapItemVisible(this, mapItem) ? 'block' : 'none';
            }
        },

        applyAlarmUpdates(updates) {
            for(let marker of updates.markersToUpdate) {
                this.markersDict[marker.siteId] = marker;
                this.rebuildMapElement(marker.siteId, marker);
            }
            for(let marker of updates.remoteSectorsMarkersToUpdate) {
                this.remoteSectorsMarkersDict[marker.remoteSectorId] = marker;
                this.rebuildMapElement(marker.remoteSectorId, marker);
            }
            for(let polyline of updates.polylinesToUpdate) {
                this.polylinesDict[polyline.siteId] = polyline;
                this.rebuildMapElement(polyline.siteId, polyline);
            }
            // If they have the info window open for a site and that site is updated then we need to have it refresh the alarm grid for it.
            if(this.infoWindowOpen && this.selectedMapItem) {
                let dict = this.selectedMapItem.isLink ? this.polylinesDict : this.markersDict;
                let id = this.selectedMapItem.siteId;
                if(this.selectedMapItem.remoteSectorId) {
                    dict = this.remoteSectorsMarkersDict;
                    id = this.selectedMapItem.remoteSectorId;
                }


                //this.selectedMapItem.alarms = dict[id].alarms;
                //this.selectedMapItem = dict[id];
                this.$refs.mapItemInfoWindow.handleAlarmUpdates(dict[id]);
            }

            // Additional stuff....
            for(let advancedFilter of this.advancedFilters) {
                advancedFilter.status = updates.advancedFiltersStatusHashMap[advancedFilter.hash] || [];
            }
            this.allDisregardAlarmsList = updates.allDisregardAlarmsList;
            this.unMatchedAlarms.list = updates.unMatchedAlarmsList;
            buildUnMatchedAlarmsListControl(this);
        },

        processAlarms(initialBuild) {
            this.alarmsList = this.$store.state.alarmsList;
            let data = {
                sites: this.geoSiteList,
                alarms: this.alarmsList,
                markers: Object.values(this.markersDict),
                polylines: Object.values(this.polylinesDict),
                remoteSectorsMarkers: Object.values(this.remoteSectorsMarkersDict),
                advancedFilters: this.advancedFilters,
                markerBuildMode: initialBuild
            }
            return new Promise((resolve, reject) => {
                this.processAlarmsWorker.onmessage = (event) => resolve(event.data);
                this.processAlarmsWorker.onerror = (error) => reject(error);
                this.processAlarmsWorker.postMessage(data);
            });
        },

        applySiteSeverityFilters() {
            let change = Object.keys(this.siteAlarmFilters).find(key => this.siteAlarmFilters[key] !== this.siteAlarmFiltersClone[key]); // Finds the filter severity type that changed
            if (!change) return; // Exit if no change
            if (['normal', 'serviceAffecting'].includes(change)) {
                this.applyVisibilityFilters();
            } 
            else {
                Object.values(this.markersDict).forEach(marker => {
                    if ((change === 'critical' && marker.criticalCount) ||
                        (change === 'major' && marker.majorCount && marker.severity !== 'critical') ||
                        (change === 'minor' && marker.minorCount && !['critical', 'major'].includes(marker.severity)) ||
                        (change === 'observational' && marker.observationalCount && !['critical', 'major', 'minor'].includes(marker.severity))) {
                            this.rebuildMapElement(marker.siteId, marker);
                    }
                });
            }
            if(this.generalSettings.clusterSites) {
                this.buildMarkerClustering();
            }
            this.siteAlarmFiltersClone = JSON.parse(JSON.stringify(this.siteAlarmFilters));
        },

        applyLinkSeverityFilters() {
            let change = Object.keys(this.linkAlarmFilters).find(key => this.linkAlarmFilters[key] !== this.linkAlarmFiltersClone[key]); // Finds the filter severity type that changed
            if (!change) return; // Exit if no change
            if (['normal', 'serviceAffecting'].includes(change)) {
                this.applyVisibilityFilters();
            } 
            else {
                Object.values(this.polylinesDict).forEach(item => {
                    this.rebuildMapElement(item.siteId, item);
                });
            }
            this.linkAlarmFiltersClone = JSON.parse(JSON.stringify(this.linkAlarmFilters));
        },

        applyVisibilityFilters() {
            for(let marker of Object.values(this.markersDict)) {
                this.mapElementsDict[marker.siteId].style.display = mapItemVisible(this, marker) ? 'block' : 'none';
            }
            for(let marker of Object.values(this.remoteSectorsMarkersDict)) {
                this.mapElementsDict[marker.remoteSectorId].style.display = mapItemVisible(this, marker) ? 'block' : 'none';
            }
            for(let polyline of Object.values(this.polylinesDict)) {
                this.mapElementsDict[polyline.siteId].setVisible(mapItemVisible(this, polyline));
            }
            if(this.generalSettings.clusterSites) {
                this.buildMarkerClustering();
            }
        },

        applySectorFiltersToDrawPolygons(sites) {
            for(let site of sites) {
                let marker = this.markersDict[site.siteId];
                if(marker) {
                    for(let sector of site.sectors) {
                        let markerSector = marker.sectors.find(s => s.sect_id == sector.sect_id);
                        if(markerSector) {
                            markerSector.draw_polygons = sector.draw_polygons;
                        }
                    }
                }
            }
            this.buildUsageDensityPolygons();
        },

        buildMarkerClustering() {
            if(this.markerClusterer) {
                this.markerClusterer.clearMarkers();
                this.markerClusterer.setMap(null);
                this.markerClusterer = null;
            }

            const colors = structuredClone(this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical);
            let advancedMarkersElements = Object.values(this.mapElementsDict).filter(el => el.tagName === "GMP-ADVANCED-MARKER" && el.style.display != 'none');
            let renderFunc = {
                render: (cluster, stats, map) => {
                    const count = cluster.count;
                    const position = cluster.position;
                    let defaultCount = 0, observationalCount = 0, minorCount = 0, majorCount = 0, criticalCount = 0;
                    for(let marker of cluster.markers) {
                        let markerDict = this.markersDict[marker.firstElementChild.id.split('_')[1]];
                        if(!markerDict) {
                            continue;
                        }
                        defaultCount += markerDict.defaultCount;
                        observationalCount += markerDict.observationalCount;
                        minorCount += markerDict.minorCount;
                        majorCount += markerDict.majorCount;
                        criticalCount += markerDict.criticalCount;
                    }
                    let color = colors.normal.foreground;
                    let backgroundColor = colors.normal.background;
                    if(criticalCount) {
                        color = colors.critical.foreground;
                        backgroundColor = colors.critical.background;
                    }
                    else if(majorCount) {
                        color = colors.major.foreground;
                        backgroundColor = colors.major.background;
                    }
                    else if(minorCount) {
                        color = colors.minor.foreground;
                        backgroundColor = colors.minor.background;
                    }
                    else if(observationalCount) {
                        color = colors.observational.foreground;
                        backgroundColor = colors.observational.background;
                    }

                    const wrapperEl = document.createElement("div");
                    wrapperEl.className = "cluster-wrapper";

                    const clusterEl = document.createElement("div");
                    clusterEl.className = "custom-cluster";
                    clusterEl.style.color = color;
                    clusterEl.style.backgroundColor = backgroundColor;
                    clusterEl.innerHTML = `<span class="cluster-count">${count}</span>`;

                    const hoverDiv = document.createElement("div");
                    hoverDiv.className = "hover-info";
                    hoverDiv.innerHTML = `
                        <div class="cluster-alarm-type">
                            <span class="icon mdi mdi-bell cluster-alarm-icon" style="color:${colors.critical.background}"></span>
                            <div class="text"><span class="cluster-alarm-text" style="color:${colors.critical.foreground}">${criticalCount}</span></div>
                        </div>

                        <div class="cluster-alarm-type">
                            <span class="icon mdi mdi-bell cluster-alarm-icon" style="color:${colors.major.background}"></span>
                            <div class="text"><span class="cluster-alarm-text" style="color:${colors.major.foreground}">${majorCount}</span></div>
                        </div>

                        <div class="cluster-alarm-type">
                            <span class="icon mdi mdi-bell cluster-alarm-icon" style="color:${colors.minor.background}"></span>
                            <div class="text"><span class="cluster-alarm-text" style="color:${colors.minor.foreground}">${minorCount}</span></div>
                        </div>

                        <div class="cluster-alarm-type">
                            <span class="icon mdi mdi-bell cluster-alarm-icon" style="color:${colors.observational.background}"></span>
                            <div class="text"><span class="cluster-alarm-text" style="color:${colors.observational.foreground}">${observationalCount}</span></div>
                        </div>
                    `;

                    wrapperEl.appendChild(clusterEl);
                    if(criticalCount || majorCount || minorCount || observationalCount) {
                        wrapperEl.appendChild(hoverDiv);
                    }
                    let zIndex = Math.round(position.lat() * 10000);
                    return new google.maps.marker.AdvancedMarkerElement({position, content: wrapperEl, zIndex: zIndex});
                }
            };
            this.markerClusterer = new MarkerClusterer({map: this.googleMapsObj, markers: advancedMarkersElements, renderer: renderFunc});
        },









        setupAutoCycleFunc() {
            // clear the auto cycle function
            clearInterval(this.autoCycleFunc);

            // rebuild the auto cycle function with the new cycle time if they have it turned on
            let autoCycleTime = Math.floor(this.autoCycleSettings.autoCycleTime * 1000);
            if(autoCycleTime < 1000) {
                autoCycleTime = 1000;
            }
            if(this.autoCycleSettings.autoCycleEnabled) {
                let self = this;
                this.autoCycleFunc = setInterval(function() {
                    // Do cycle stuff here!
                    let len = self.autoCycleSettings.mapViews.length;
                    let exit = false;

                    while(!exit) {
                        if(self.currentCycleMapViewIndex >= len) {
                            self.currentCycleMapViewIndex = 0;
                            exit = true;
                        }
                        for(self.currentCycleMapViewIndex; self.currentCycleMapViewIndex < len; self.currentCycleMapViewIndex++) {
                            let activeMapView = self.autoCycleSettings.mapViews[self.currentCycleMapViewIndex];
                            if(activeMapView) {
                                let mapView = self.geoMapViews.find(v => v.user_id == activeMapView.user_id && v.view_name == activeMapView.view_name);
                                self.selectedGeoMapView = mapView;
                                self.applyGeoMapView();
                                self.currentCycleMapViewIndex++;
                                return;
                            }
                        }
                    }
                }, autoCycleTime);
            }
        },
        
        keyDownListener: function(keyEvent) {
            if(keyEvent.shiftKey) {
                this.shiftKeyPressed = true;
            }
            if(keyEvent.shiftKey && keyEvent.code === "Space") {
                this.showGeoMapSettings = !this.showGeoMapSettings;
            }
        },
        keyUpListener: function(keyEvent) {
            if(!keyEvent.shiftKey) {
                this.shiftKeyPressed = false;
            }
        }
    },

    watch: {
        // Site alarms severity needs a special watch function because it has to generatre a different icon(colors) rather than just show/hide.
        siteAlarmFilters: {
            handler(newVal, oldVal) {
                this.applySiteSeverityFilters();
            },
            deep: true
        },

        linkAlarmFilters: {
            handler(newVal, oldVal) {
                this.applyLinkSeverityFilters();
            },
            deep: true
        },

        siteTagFilters: {
            handler(newVal, oldVal) {
                this.applyVisibilityFilters();
            }
        },
        siteTechnicianFilters: {
            handler(newVal, oldVal) {
                this.applyVisibilityFilters();
            }
        },
        siteNetworkCategoryFilters: {
            handler(newVal, oldVal) {
                this.applyVisibilityFilters();
            }
        },

        generalSettings: {
            handler(newVal, oldVal) {
                if(this.generalSettings.mapType != this.generalSettingsClone.mapType) {
                    this.googleMapsObj.setMapTypeId(newVal.mapType);
                }
                if(this.generalSettings.mapTheme != this.generalSettingsClone.mapTheme || this.generalSettings.featureDensityRoads != this.generalSettingsClone.featureDensityRoads || this.generalSettings.featureDensityLandmarks != this.generalSettingsClone.featureDensityLandmarks || this.generalSettings.featureDensityLabels != this.generalSettingsClone.featureDensityLabels) {
                    let themeJson = GoogleMapStyles[newVal.mapTheme] || [];
                    let roadsDensity = GoogleMapStyleFeatureDensityModifiers.roads[this.generalSettings.featureDensityRoads];
                    let landmarksDensity = GoogleMapStyleFeatureDensityModifiers.landmarks[this.generalSettings.featureDensityLandmarks];
                    let labelsDensity = GoogleMapStyleFeatureDensityModifiers.labels[this.generalSettings.featureDensityLabels];
                    themeJson = themeJson.concat(roadsDensity, landmarksDensity, labelsDensity);
                    this.googleMapsObj.mapTypes.set("map_theme", new google.maps.StyledMapType(themeJson));
                    this.googleMapsObj.setMapTypeId("map_theme");
                }
                if(this.generalSettings.networkCategoryIcons != this.generalSettingsClone.networkCategoryIcons) {
                    // They toggled the icon type. We need to go thru all the markers that have a network category icon and rebuild them.
                    TELSA.loading(true);
                    //let start = TELSA.moment().unix();
                    let markers = Object.values(this.markersDict);
                    let index = 0;
                    let CHUNK_SIZE = 1000;
                    let self = this;
                    function processChunk(deadline) {
                        // Loop through markers as long as there’s idle time left
                        while (index < markers.length && deadline.timeRemaining() > 0) {
                            for (let i = 0; i < CHUNK_SIZE && index < markers.length; i++) {
                                self.rebuildMapElement(markers[index].siteId, markers[index]);
                                index++;
                            }
                        }
                        // If there are more markers to process, request the next idle callback
                        if (index < markers.length) {
                            requestIdleCallback(processChunk);
                        } else {
                            //console.log(`IT TOOK ${(TELSA.moment().unix()) - start} SECONDS`);
                            TELSA.loading(false);
                        }
                    }
                    requestIdleCallback(processChunk);
                }
                if(this.generalSettings.showLinkDirectionality != this.generalSettingsClone.showLinkDirectionality) {
                    Object.values(this.polylinesDict).forEach(polyline => {
                        this.rebuildMapElement(polyline.siteId, polyline);
                    });
                }
                if(this.generalSettings.clusterSites != this.generalSettingsClone.clusterSites) {
                    if(this.generalSettings.clusterSites) {
                        this.buildMarkerClustering();
                    }
                    else {
                        if(this.markerClusterer) {
                            this.markerClusterer.clearMarkers();
                            let advancedMarkersElements = Object.values(this.mapElementsDict).filter(el => el.tagName === "GMP-ADVANCED-MARKER");
                            advancedMarkersElements.forEach(marker => marker.map = this.googleMapsObj);
                        }
                    }
                }
                this.generalSettingsClone = JSON.parse(JSON.stringify(this.generalSettings));
            },
            deep: true
        },

        placesSearchValue: {
            handler(val) {
                handlePlacesSearchValue(this, val);
            }
        },

        usageDensityMarkers: {
            handler(val) {
                this.buildUsageDensityPolygons();
            }
        }
    },

    async mounted() {
        document.addEventListener("keydown", this.keyDownListener);
        document.addEventListener("keyup", this.keyUpListener);
        this.siteAlarmFiltersClone = JSON.parse(JSON.stringify(this.siteAlarmFilters));
        this.linkAlarmFiltersClone = JSON.parse(JSON.stringify(this.linkAlarmFilters));
        this.generalSettingsClone = JSON.parse(JSON.stringify(this.generalSettings));
        this.setup();
        this.animationFrameId = requestAnimationFrame(this.animatePolylineSymbols);

        // fetchCoverageData(this).then(r => {
        //     console.log('fetchCoverageData IS ALL DONE!!!!!!!!!!');
        // });
    },

    destroyed() {
        google.maps.event.clearInstanceListeners(this.googleMapsObj);
        this.googleMapsObj = null;

        document.removeEventListener("keydown", this.keyDownListener);
        document.removeEventListener("keyup", this.keyUpListener);
        this.dragStartListener.remove();
        this.dragStartListener = null;
        
        if(this.animationFrameId !== null) {
            cancelAnimationFrame(this.animationFrameId);
        }
        clearInterval(this.processAlarmsIntervalFunc);
        clearTimeout(this.usageDensityPolygonFetchTimeout);
        this.processAlarmsWorker.terminate();
        this.processAlarmsWorker = null; // Super important!

        // cleanup map elements and listeners
        Object.values(this.mapElementsDict).forEach(m => {
            google.maps.event.clearInstanceListeners(m);
            m.map = null;
            m.setMap(null);
        });
        this.usageDensityPolygonElements.forEach(x => x.setMap(null));
        removeListeners(this, []); // removes all

        if(document.getElementById('js-geomap')) {
            document.getElementById('js-geomap').innerHTML = ''; // wipe it, in case anything stuck to it
            document.getElementById('js-geomap').remove();
        }
        if(document.getElementById('unmatched-alarms-list-control')) {
            element.remove();
        }
        this.showViewControls = null;
        if(document.getElementById('google-maps-directions-container')) {
            document.getElementById('google-maps-directions-container').remove();
        }
        if(document.getElementById('show-geomap-view-management-toggle')) {
            document.getElementById('show-geomap-view-management-toggle').remove();
        }
        
        this.AdvancedMarkerElement = null;
        this.infoWindowElementCtr = null;
        this.placesAutoCompleteService = null;
        this.placesService = null;
        this.placesSearchResults = null;
        this.placesMarkers = null;

        if(this.markerClusterer) {
            this.markerClusterer.clearMarkers();
            this.markerClusterer.setMap(null);
            this.markerClusterer = null;
        }

        this.markersDict = null;
        this.polylinesDict = null;
        this.remoteSectorsMarkersDict = null;

        this.mapElementsDict = null;

        this.geoSiteList = null;
        this.remoteSectorsLinkLines = null;
        this.siteTags = null;
        this.siteTechnicians = null;
        this.networkCategories = null;
        this.alarmGridResources = null;
        this.alarmViews = null;
        this.advancedFiltersValueLists = null;
        this.geoMapViews = null;

        this.heatmapPolygonData = null;
        this.usageDensityPolygons = null;
        this.usageDensityPolygonElements = null;

        this.alarmsList = null;
        this.unMatchedAlarms = null;

        this.autoCycleFunc = null;

        this.generalSettings = null;
        this.generalSettingsClone = null;
        this.siteAlarmFilters = null;
        this.linkAlarmFilters = null;
        this.siteAlarmFiltersClone = null;
        this.linkAlarmFiltersClone = null;
        this.siteTagFilters = null;
        this.siteTechnicianFilters = null;
        this.siteNetworkCategoryFilters = null;
        this.advancedFilters = null;
    }

  
};
</script>













<style scoped>

    .widget-mode {
        padding: 0px !important;
    }

    .geomap-view-select-default-text {
        color: yellow;
        position: absolute;
        right: 20px;
        text-align: right;
        font-size: 11px;
        font-weight: bold;
    }

</style>

<style>
    /* TOGGLE MAP CONTROLS */
    #show-filters-toggle {
        background-color: #ffffff;
        height: 40px;
        width: 40px;
        margin-top: 10px;
        margin-left: 10px;
        cursor: pointer;
        transition: all 0.3s;
    }
    #show-filters-toggle:hover {
        background-color: #ebebeb;
    }
    #show-filters-toggle #show-filters-toggle-icon {
        display: inline-block;
        color: #666666;
        font-size: 26px;
        margin-top: 5px;
        margin-left: 8px;
        width: 25px;
        height: 25px;
    }

    /* VIEW QUICK SELECT */
    .geomap-view-select {
        position: absolute !important;
        top: 25px !important;
        left: 75px !important;
        width: 250px !important;
        min-height: 40px !important;
        height: 40px !important;
        background-color: #ffffff !important;
    }
    .geomap-view-select .v-input__slot {
        min-height: 40px !important;
        height: 40px !important;
    }

    .widget-mode .geomap-view-select {
        position: absolute !important;
        top: 10px !important;
        left: 60px !important;
        width: 210px !important;
        min-height: 40px !important;
        height: 40px !important;
        background-color: #ffffff !important;
    }

    /* GEOMAP VIEW MANAGEMENT */
    #show-geomap-view-management-toggle {
        background-color: #ffffff;
        height: 40px;
        width: 40px;
        margin-top: 10px;
        margin-left: 270px;
        cursor: pointer;
    }
    #show-geomap-view-management-toggle:hover {
        background-color: #ebebeb;
    }
    #show-geomap-view-management-toggle #show-geomap-view-management-toggle-icon {
        display: inline-block;
        color: #666666;
        font-size: 23px;
        margin-top: 8px;
        margin-left: 9px;
        width: 25px;
        height: 25px;
    }

    /* SAVE GEOMAP VIEW */
    #save-geomap-view-button {
        background-color: #ffffff;
        height: 40px;
        width: 40px;
        margin-top: 60px;
        margin-left: -40px;
        cursor: pointer;
    }
    #save-geomap-view-button:hover {
        background-color: #ebebeb;
    }
    #save-geomap-view-button #save-geomap-view-button-icon {
        display: inline-block;
        color: #666666;
        font-size: 26px;
        margin-top: 5px;
        margin-left: 8px;
        width: 25px;
        height: 25px;
    }

    /* EDIT MAP SETTINGS */
    #edit-geomap-settings-button {
        background-color: #ffffff;
        height: 40px;
        width: 40px;
        margin-top: 10px;
        margin-left: 10px;
        cursor: pointer;
    }
    #edit-geomap-settings-button:hover {
        background-color: #ebebeb;
    }
    #edit-geomap-settings-button #edit-geomap-settings-button-icon {
        display: inline-block;
        color: #666666;
        font-size: 23px;
        margin-top: 8px;
        margin-left: 9px;
        width: 25px;
        height: 25px;
    }


    /* FILTERED OUT INFO */
    /* #map-filtered-out-info-control {
        background-color: #ffffff;
        height: 40px;
        width: 90px;
        margin-top: -40px;
        margin-left: 60px;
        position: relative;

    }
    #map-filtered-out-info-control .map-filtered-out-info-container {
        display: inline-block;
        text-align: center;
        height: 100%;
        width: 50%;
        padding-top: 5px;
        position: absolute;
        overflow: hidden;
    }
    #map-filtered-out-info-control .map-filtered-out-info-container:last-child {
        left: 50%;
    }
    #map-filtered-out-info-control .map-filtered-out-info-container .map-filtered-out-number {
        display: inline-block;
        color: #c42111;
        font-weight: bold;
        font-size: 22px;
        letter-spacing: -2px;

    }
    #map-filtered-out-info-control .map-filtered-out-info-container .map-filtered-out-icon {
        display: inline-block;
        color: #c42111;
        font-size: 15px;
        margin-top: 8px;
        margin-left: 0px;
    } */
    

    /* CYCLE CONTROLS */
    #cycle-map-views-control {
        background-color: #fff;
        border-radius: 3px;
        box-shadow: 0 2px 6px rgba(0,0,0,.1);
        cursor: initial;
        margin-top: -40px;
        margin-left: 60px;
        width: 250px;
        text-align: center;
        height: 40px;
        transition: all 0.3s;
        overflow: hidden;
    }
    #cycle-map-views-control.expanded {
        height: 500px;
        transition: all 0.3s;
        overflow-y: auto;
    }
    #cycle-map-views-control-title {
        color: rgb(25,25,25);
        font-family: Roboto,Arial,sans-serif;
        font-size: 16px;
        line-height: 40px;
        padding-left: 5px;
        padding-right: 5px;
        cursor: pointer;
    }
    #cycle-map-views-control-title:hover {
        background-color: #ebebeb;
    }
    .cycle-map-views-cycle-settings-container {
        display: block;
        position: relative;
        padding-left: 10px;
    }
    .map-views-cycle-control {
        text-align: left;
        margin-bottom: 5px;
    }
    .map-views-cycle-control label {
        display: inline-block;
        padding-top: 7px;
    }
    #map-views-cycle-time {
        outline: none;
        color: #000000;
        border: #000000 solid 1px;
        width: 50px;
        font-size: 10pt;
        padding: 2px;
    }
    #cycle-map-views-control #cycle-map-views-list-container {
        margin-top: 20px;
        overflow: auto;
        max-height: 316px;
        border-top: grey solid 1px;
    }
    .map-view-container {
        text-align: left;
        padding: 5px;
        border-bottom: grey solid 1px;
        position: relative;
        overflow: hidden;
    }
    .map-view-container:hover {
        background-color: #ebebeb;
    }
    .map-view-container .text-container {
        display: inline-block;
        color: #000000;
        margin-left: 5px;
        margin-top: 5px;
        float: left;
    }
    .map-view-container .text-container .map-view-name {
        color: #000000;
        font-size: 11pt;
        display: block;
        width: 150px;
    }
    .map-view-container .text-container .map-view-name-edit {
        color: #000000;
        font-size: 11pt;
        width: 150px;
        border: #000000 solid 1px;
        padding: 2px;
        outline: none;
        display: block;
    }
    .map-view-container .text-container .map-view-created-by {
        font-size: 9pt;
        color: #000000;
        display: block;
    }
    .map-view-container .button-container {
        display: inline-block;
        top: 10px;
        right: 5px;
        position: absolute;
    }

    /* SEARCH CONTROL */
    #search-control-toggle {
        background-color: #ffffff;
        height: 40px;
        width: 40px;
        margin-top: 10px;
        margin-right: 10px;
        cursor: pointer;
        transition: all 0.3s;
    }
    #search-control-toggle:hover {
        background-color: #ebebeb;
    }
    #search-control-toggle #search-control-icon {
        display: inline-block;
        color: #666666;
        font-size: 26px;
        margin-top: 5px;
        margin-left: 8px;
        width: 25px;
        height: 25px;
    }
    #search-control-toggle .v-autocomplete__content.v-menu__content {
        right: 0px !important;
        left: -310px !important;
    }
    .search-bar {
        position: absolute !important;
        top: 25px !important;
        right: 75px !important;
        width: 300px !important;
        min-height: 40px !important;
    }
    .search-bar .v-input__slot {
        min-height: 40px !important;
    }
    .widget-container .search-bar {
        top: 10px !important;
        right: 60px !important;
    }


    /* MAKER CONTROL */
    #marker-control-toggle {
        background-color: #ffffff;
        height: 40px;
        width: 40px;
        margin-top: 10px;
        margin-right: 10px;
        cursor: pointer;
        transition: all 0.3s;
    }
    #marker-control-toggle:hover {
        background-color: #ebebeb;
    }
    #marker-control-toggle #marker-control-icon {
        display: inline-block;
        color: #666666;
        font-size: 26px;
        margin-top: 5px;
        margin-left: 8px;
        width: 25px;
        height: 25px;
    }
    #marker-control-toggle .v-autocomplete__content.v-menu__content {
        right: 0px !important;
        left: -310px !important;
    }
    .places-search-bar {
        position: absolute !important;
        top: 75px !important;
        right: 75px !important;
        width: 300px !important;
        min-height: 40px !important;
    }
    .places-search-bar .v-input__slot {
        min-height: 40px !important;
    }
    .widget-container .places-search-bar {
        top: 10px !important;
        right: 60px !important;
    }
    #marker-control-toggle .selected {
        color: pink !important;
    }
    

    /* FULLSCREEN CONTROL */
    #fullscreen-control {
        background-color: #ffffff;
        height: 40px;
        width: 40px;
        margin-top: 10px;
        margin-right: 10px;
        cursor: pointer;
        transition: all 0.3s;
    }
    #fullscreen-control:hover {
        background-color: #ebebeb;
    }
    #fullscreen-control #fullscreen-control-icon {
        display: inline-block;
        color: #666666;
        font-size: 38px;
        margin-top: -1px;
        margin-left: 1px;
        width: 25px;
        height: 25px;
    }

    /* ACTIVE VIEW BOTTOM LABEL */
    #active-view-name-text-container {
        margin-bottom: 10px;
        color: rgb(25,25,25);
        font-size: 16pt;
        background-color: #ffffff;
        border-radius: 3px;
        padding: 5px 10px;
        box-shadow: 0 2px 6px rgba(0,0,0,.3);
        display: none;
        font-family: Roboto,Arial,sans-serif;
    }

    /* NAVIGATION DIRECTIONS */
    #google-maps-directions-container {
        padding: 5px;
        margin-right: 10px;
        width: 400px;
        max-height: 800px;
        height: calc(100vh - 400px);
        overflow: auto;
        background-color: #ffffff;
        box-shadow: 0 2px 6px rgba(0,0,0,.1);
        display: none;
    }
    #google-maps-directions-close {
        position: absolute;
        top: 17px;
        right: 10px;
        cursor: pointer;
    }
    #google-maps-directions-close span {
        font-size: 40px;
        color: red;
    }
    #google-maps-directions-close:hover span {
        box-shadow: 0 2px 6px rgba(0,0,0,.4);
    }

    /* UNMATCHED ALARMS */
    #unmatched-alarms-list-control {
        background-color: #fff;
        border-radius: 3px;
        box-shadow: 0 2px 6px rgba(0,0,0,.1);
        cursor: initial;
        margin-left: 10px;
        width: 50px;
        text-align: center;
        height: 40px;
        transition: all 0.3s;
        overflow: hidden;
        display: none;
    }
    #unmatched-alarms-list-control.expanded {
        height: 190px;
        width: 250px;
        transition: all 0.3s;
    }
    #unmatched-alarms-list-control-title {
        cursor: pointer;
        color: #FB8C00;
        font-weight: bold;
        font-size: 32px;
        display: block;
        animation: alertBlink 1s infinite;
    }
    #unmatched-alarms-list-control-title:hover {
        background-color: #ebebeb;
    }

    #unmatched-alarms-list-control-list {
        font-family: Roboto,Arial,sans-serif;
        padding: 0 15px 5px 15px;
    }
    #unmatched-alarms-list-control-list .total {
        color: rgb(25,25,25);
        font-family: Roboto,Arial,sans-serif;
        font-size: 16px;
        line-height: 40px;
        padding-left: 5px;
        padding-right: 5px;
        display: block;
    }
    #unmatched-alarms-list-control-list .alarm-types {
        position: relative;
    }
    #unmatched-alarms-list-control-list .alarm-types .type {
        display: inline-block;
        position: relative;
    }
    #unmatched-alarms-list-control-list .alarm-types .type .icon {
        font-size: 40px;
    }
    #unmatched-alarms-list-control-list .alarm-types .type .text {
        font-size: 12px;
        width: 100%;
        text-align: center;
        top: 16px;
        position: absolute;
        font-weight: bold;
    }
    #unmatched-alarms-list-control-list .info-text {
        color: #000000;
    }
    @keyframes alertBlink{
        0%{color: #FB8C00;}
        49%{color: #FB8C00;}
        60%{color: red;}
        99%{color: red;}
        100%{color: red;}
    }

</style>

<style>

    /* CSS for the auto-cycle switch */
    #cycle-map-views-control .switch {
        position: relative;
        display: inline-block;
        width: 50px;
        height: 26px;

        margin-left: 10px;
    }
    #cycle-map-views-control .switch.small {
        width: 40px;
        height: 20px;
        margin-left: 0px;
    }
    #cycle-map-views-control .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }
    #cycle-map-views-control .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    #cycle-map-views-control .slider:before {
        position: absolute;
        content: "";
        height: 18px;
        width: 18px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    #cycle-map-views-control .slider.small:before {
        height: 12px;
        width: 12px;
    }

    #cycle-map-views-control input:checked + .slider {
        background-color: #c42111;
    }

    #cycle-map-views-control input:focus + .slider {
        box-shadow: 0 0 1px #c42111;
    }

    #cycle-map-views-control input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }
    #cycle-map-views-control input:checked + .slider.small:before {
        -webkit-transform: translateX(21px);
        -ms-transform: translateX(21px);
        transform: translateX(21px);
    }
    #cycle-map-views-control .slider.round {
        border-radius: 34px;
    }

    #cycle-map-views-control .slider.round:before {
        border-radius: 50%;
    }

    .map-views-new-save-button {
        display: inline-block;
    }
    .map-views-new-save-button button {
        color: #ffffff;
        background-color: #c42111;
        text-transform: uppercase;
        padding: 5px;
        outline: none;
        font-size: 11pt;
        border-radius: 3px;
        margin-top: 20px;
        width: 80px;
        margin-right: 5px;
        margin-left: 5px;
        margin-bottom: 15px;
    }

    .polygon-info {
        padding: 10px;
        color: #000000;
    }


    .cluster-wrapper {
        position: relative;
        display: inline-block;
    }
    .custom-cluster {
        border: solid 2px #000000;
        border-radius: 10px;
        padding: 2px 8px;
    }
    .cluster-count {
        font-size: 20px;
        font-weight: bold;
    }
    .hover-info {
        display: none;
        position: absolute;
        top: 100%; /* directly under the cluster */
        left: -62px;
        background: #ffffff;
        padding: 4px;
        border: 2px solid #000000;
        border-radius: 10px;
        z-index: 100;
        white-space: nowrap;
    }
    .hover-info .cluster-alarm-type {
        display: inline-block;
        position: relative;
    }
    .hover-info .cluster-alarm-type .cluster-alarm-icon {
        font-size: 34px;
    }
    .hover-info .cluster-alarm-type .cluster-alarm-text {
        font-size: 12px;
        position: absolute;
        top: 14px;
        text-align: center;
        width: 34px;
    }
    .cluster-wrapper:hover .hover-info {
        display: block;
    }
</style>

